import React from 'react';
import { useShareThumbnailCodeStore } from './store';

export const ShareThumbnailCodePreview = () => {
  const { thumbnailElement } = useShareThumbnailCodeStore();

  if (!thumbnailElement) {
    return null;
  }

  return (
    <div className='absolute bottom-[999rem]' style={{ maxHeight: 0 }}>
      {thumbnailElement}
    </div>
  );
};
